import React from 'react';
import { Icon } from '@rv-life/design-system';
import css from './DevToolsTrigger.module.css';
import type { DevToolsPosition } from '../../utils';

interface DevToolsTriggerProps {
	onClick: () => void;
	isActive?: boolean;
	position: DevToolsPosition;
}

const DevToolsTrigger = ({ onClick, isActive = false, position }: DevToolsTriggerProps) => {
	return (
		<button
			className={`${css.devToolsTrigger} ${css[position]} ${isActive ? css.active : ''}`}
			onClick={onClick}
			aria-label="Open Development Tools"
			type="button"
		>
			<Icon name="settings" />
		</button>
	);
};

export default DevToolsTrigger;
